import Image from 'next/image'
import { useTranslation } from 'src/utils/i18n'

export const EMPTY_TYPES = {
  SYNC_FAILED: 'syncFailed',
  DEVICE_NOT_CONNECTED: 'deviceNotConnected',
  NO_DATA: 'noData'
}

const EMPTY_STATE_MAP = {
  [EMPTY_TYPES.SYNC_FAILED]: {
    icon: '/image/synchronizationfailed.svg',
    labelKey: 'Synchronization failed'
  },
  [EMPTY_TYPES.DEVICE_NOT_CONNECTED]: {
    icon: '/image/devicenotconnected.svg',
    labelKey: 'Device not connected'
  },
  [EMPTY_TYPES.NO_DATA]: {
    icon: '/image/nodataavailable..svg',
    labelKey: 'No data available.'
  }
}

const EmptyState = ({ type = EMPTY_TYPES.NO_DATA, className = '' }) => {
  const { t } = useTranslation('common')
  const state = EMPTY_STATE_MAP[type] || EMPTY_STATE_MAP[EMPTY_TYPES.NO_DATA]

  return (
    <div
      className={`flex flex-1 flex-col items-center justify-center w-full h-full min-h-0 text-center px-4 py-6 ${className}`}
    >
      <Image src={state.icon} width={135} height={113} alt='' priority />
      <p className='mt-4 mb-0 text-[14px] leading-[22px] font-normal font-[Poppins] text-[#484B60]'>
        {t(state.labelKey) || state.labelKey}
      </p>
    </div>
  )
}

export default EmptyState
